module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_Light-45538cfd70a25a83628cf9da71c3a6c5.png";